import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MultiAgentSystemsPage from "@/pages/service/MultiAgentSystemsPage";

export const Route = createFileRoute("/service/multi-agent-systems")({
  head: () => pageHead("Multi-Agent Systems & Agentic AI", "Multi-agent systems consulting and engineering. Agentic AI with context engineering, knowledge graph integration, RAG, and agent orchestration for enterprise workflows.", "/service/multi-agent-systems", false),
  component: MultiAgentSystemsPage,
});
